'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { LazyImage, SmartIcon } from '@/shared/blocks/common';
import { BorderBeam } from '@/shared/components/magicui/border-beam';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/shared/components/ui/accordion';
import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { cn } from '@/shared/lib/utils';
import { Section } from '@/shared/types/blocks/landing';
export function FeaturesAccordion(t0) {
  const $ = _c(41);
  const {
    section,
    className
  } = t0;
  const [activeItem, setActiveItem] = useState("item-1");
  let images;
  if ($[0] !== section.items) {
    images = {};
    section.items?.forEach((item, idx) => {
      images[`item-${idx + 1}`] = {
        image: item.image?.src ?? "",
        alt: item.image?.alt || item.title || ""
      };
    });
    $[0] = section.items;
    $[1] = images;
  } else {
    images = $[1];
  }
  let t1;
  if ($[2] !== className || $[3] !== section.className) {
    t1 = cn("overflow-x-hidden py-16 md:py-24", section.className, className);
    $[2] = className;
    $[3] = section.className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== section.title) {
    t2 = <h2 className="text-foreground mb-4 text-3xl font-semibold tracking-tight md:text-4xl">{section.title}</h2>;
    $[5] = section.title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== section.description) {
    t3 = <p className="text-muted-foreground mb-6 md:mb-12 lg:mb-16">{section.description}</p>;
    $[7] = section.description;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <ScrollAnimation><div className="mx-auto max-w-4xl text-center text-balance">{t2}{t3}</div></ScrollAnimation>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => setActiveItem(value as string);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== section.items) {
    t6 = section.items?.map(_temp);
    $[13] = section.items;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== activeItem || $[16] !== t6) {
    t7 = <ScrollAnimation delay={0.1} direction="left"><Accordion type="single" value={activeItem} onValueChange={t5} className="w-full">{t6}</Accordion></ScrollAnimation>;
    $[15] = activeItem;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute inset-0 right-0 ml-auto w-15 border-l bg-[repeating-linear-gradient(-45deg,var(--color-border),var(--color-border)_1px,transparent_1px,transparent_8px)]" />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `${activeItem}-id`;
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 6,
      scale: 0.98
    };
    t11 = {
      opacity: 1,
      y: 0,
      scale: 1
    };
    t12 = {
      opacity: 0,
      y: 6,
      scale: 0.98
    };
    t13 = {
      duration: 0.2
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
  }
  const t14 = images[activeItem];
  const t15 = images[activeItem];
  let t16;
  if ($[23] !== t14.image || $[24] !== t15.alt) {
    t16 = <LazyImage src={t14.image} className="size-full object-cover object-left-top dark:mix-blend-lighten" alt={t15.alt} />;
    $[23] = t14.image;
    $[24] = t15.alt;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t16 || $[27] !== t9) {
    t17 = <div className="bg-background relative aspect-76/59 w-full min-w-0 rounded-2xl sm:w-[calc(3/4*100%+3rem)]"><AnimatePresence mode="wait"><motion.div key={t9} initial={t10} animate={t11} exit={t12} transition={t13} className="size-full overflow-hidden rounded-2xl border shadow-md">{t16}</motion.div></AnimatePresence></div>;
    $[26] = t16;
    $[27] = t9;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <BorderBeam duration={6} size={200} className="from-transparent via-yellow-700 to-transparent dark:via-white/50" />;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t17) {
    t19 = <ScrollAnimation delay={0.2} direction="right"><div className="bg-background relative flex min-w-0 flex-shrink overflow-hidden rounded-3xl border p-2">{t8}{t17}{t18}</div></ScrollAnimation>;
    $[30] = t17;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t19 || $[33] !== t7) {
    t20 = <div className="grid min-w-0 gap-12 sm:px-6 md:grid-cols-2 lg:gap-20 lg:px-0">{t7}{t19}</div>;
    $[32] = t19;
    $[33] = t7;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20 || $[36] !== t4) {
    t21 = <div className="container space-y-8 overflow-x-hidden px-2 sm:px-6 md:space-y-16 lg:space-y-20 dark:[--color-border:color-mix(in_oklab,var(--color-white)_10%,transparent)]">{t4}{t20}</div>;
    $[35] = t20;
    $[36] = t4;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t1 || $[39] !== t21) {
    t22 = <section className={t1}>{t21}</section>;
    $[38] = t1;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  return t22;
}
function _temp(item_0, idx_0) {
  return <AccordionItem value={`item-${idx_0 + 1}`} key={idx_0}><AccordionTrigger><div className="flex items-center gap-2 text-base">{item_0.icon && <SmartIcon name={item_0.icon as string} size={24} />}{item_0.title}</div></AccordionTrigger><AccordionContent>{item_0.description}</AccordionContent></AccordionItem>;
}